/**
 * Sticky Add to Cart Bar Web Component
 * Appears when scrolling past the main product CTA to capture impulse conversions.
 * Automatically adds bottom padding to the document body when active to ensure
 * footer content and buttons are never covered.
 */

window.themeBus = window.themeBus || {
  events: {},
  subscribe(event, callback) {
    if (!this.events[event]) this.events[event] = [];
    this.events[event].push(callback);
    return () => {
      this.events[event] = this.events[event].filter(cb => cb !== callback);
    };
  },
  publish(event, data) {
    if (this.events[event]) {
      this.events[event].forEach(cb => {
        try { cb(data); } catch (e) { console.error('themeBus listener error:', e); }
      });
    }
  }
};

class StickyATC extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  init() {
    this.mainButton = document.querySelector('.product-form__submit, [name="add"]');
    this.variantSelect = this.querySelector('select[name="id"]');
    this.priceDisplay = this.querySelector('.sticky-atc__price');
    this.buyButton = this.querySelector('.sticky-atc__btn');

    if (!this.mainButton) return;

    this.initObserver();
    this.initVariantListener();

    if (this.buyButton && !this.buyButton._hasListener) {
      this.buyButton._hasListener = true;
      this.buyButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.buyButton.getAttribute('aria-disabled') === 'true') return;
        const variantId = this.variantSelect ? this.variantSelect.value : this.dataset.variantId;
        if (variantId && window.themeCart) {
          const tierRadio = document.querySelector('input[name^="quantity-tier"]:checked');
          const tierLabel = document.querySelector('.qty-breaks__item.is-selected');
          const mainQty = document.querySelector('product-form input[name="quantity"], [id^="product-form-"] input[name="quantity"]');
          const externalQty = document.querySelector('.product-v2__quantity-selector-wrap input[name="quantity"]');
          let qty = 1;
          if (tierRadio && tierRadio.value) {
            qty = parseInt(tierRadio.value, 10) || 1;
          } else if (tierLabel && tierLabel.dataset.tierQty) {
            qty = parseInt(tierLabel.dataset.tierQty, 10) || 1;
          } else if (externalQty && externalQty.value) {
            qty = parseInt(externalQty.value, 10) || 1;
          } else if (mainQty && mainQty.value) {
            qty = parseInt(mainQty.value, 10) || 1;
          }
          this.buyButton.classList.add('loading');
          this.buyButton.setAttribute('aria-disabled', 'true');
          window.themeCart.add(parseInt(variantId, 10), qty)
            .catch((err) => console.error('Sticky ATC error:', err))
            .finally(() => {
              this.buyButton.classList.remove('loading');
              this.buyButton.removeAttribute('aria-disabled');
            });
        }
      });
    }

    if (this.variantSelect && !this.variantSelect._hasListener) {
      this.variantSelect._hasListener = true;
      this.variantSelect.addEventListener('change', (e) => {
        const option = e.target.selectedOptions[0];
        if (option && this.priceDisplay && option.dataset.price) {
          this.priceDisplay.textContent = option.dataset.price;
        }
      });
    }
  }

  initObserver() {
    if (this._observer) {
      this._observer.disconnect();
    }

    if ('IntersectionObserver' in window && this.mainButton) {
      this._observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // If main button is NOT intersecting and above the viewport, show sticky bar
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            this.show();
          } else {
            this.hide();
          }
        });
      }, {
        threshold: 0
      });

      this._observer.observe(this.mainButton);
    }
  }

  show() {
    this.classList.add('is-visible');
    const barHeight = this.offsetHeight || 72;
    document.body.style.paddingBottom = `${barHeight}px`;
  }

  hide() {
    this.classList.remove('is-visible');
    document.body.style.paddingBottom = '';
  }

  cleanup() {
    if (this._observer) {
      this._observer.disconnect();
    }
    document.body.style.paddingBottom = '';
  }

  initVariantListener() {
    if (window.themeBus && !this._busSubscribed) {
      this._busSubscribed = true;
      window.themeBus.subscribe('variant:changed', (data) => {
        if (!data || !data.variant) return;
        if (this.variantSelect) {
          this.variantSelect.value = data.variant.id;
          const option = this.variantSelect.selectedOptions[0];
          if (option && this.priceDisplay && option.dataset.price) {
            this.priceDisplay.textContent = option.dataset.price;
          }
        }
        this.dataset.variantId = data.variant.id;

        // Update button state if sold out
        if (this.buyButton) {
          const isAvail = Boolean(data.variant && data.variant.available);
          if (!isAvail) {
            this.buyButton.setAttribute('disabled', 'disabled');
            this.buyButton.style.display = 'none';
          } else {
            this.buyButton.removeAttribute('disabled');
            this.buyButton.style.display = '';
            this.buyButton.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
          }
          const soldOutBadge = this.querySelector('.sticky-atc__sold-out-badge');
          if (soldOutBadge) soldOutBadge.style.display = isAvail ? 'none' : '';
        }
      });
    }
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyATC);
}
